import { z } from 'zod';

import { schemaBigDecimal } from '../../../../utils/schema.utils';
import { schemaEuropaceAntragstellerzuordnung } from '../../Antragstellerzuordnung.schema';

/*
	https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-import-api/#sonstige-ausgabe-und-mietausgabe

	{
		"betragMonatlich": schemaBigDecimal,
		"gehoertZuAntragsteller": Antragstellerzuordnung
	}

*/
export const schemaEuropaceSonstigeAusgabeUndMietAusgabe = z.object({
    betragMonatlich: z.optional(schemaBigDecimal),
    europaceId: z.optional(z.string().min(1)),
    gehoertZuAntragsteller: z.optional(schemaEuropaceAntragstellerzuordnung),
    id: z.string().min(1),
});

export type SchemaEuropaceSonstigeAusgabeUndMietAusgabe = z.infer<typeof schemaEuropaceSonstigeAusgabeUndMietAusgabe>;
